import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { GraphQLLetter } from '@sola/schema/dotcom/supporters/schema.generated.ts';
export const usePrimaryCtaLetterRead = t0 => {
  const $ = _c(16);
  const {
    letters
  } = t0;
  const {
    t
  } = useTranslation("my");
  const count = letters.length;
  const t1 = letters[0]?.beneficiary?.name ?? "";
  const t2 = letters[1]?.beneficiary?.name ?? "";
  const t3 = count === 2 ? "two" : undefined;
  let t4;
  if ($[0] !== count || $[1] !== t || $[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
    t4 = t("my:primaryCtaLetterRead.title", {
      name: t1,
      name2: t2,
      count,
      context: t3
    });
    $[0] = count;
    $[1] = t;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const title = t4;
  const t5 = letters[0]?.beneficiary?.name ?? "";
  const t6 = letters[1]?.beneficiary?.name ?? "";
  let t7;
  if ($[6] !== count || $[7] !== t || $[8] !== t5 || $[9] !== t6) {
    t7 = t("my:primaryCtaLetterRead.subtitle", {
      name: t5,
      name2: t6,
      count
    });
    $[6] = count;
    $[7] = t;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const subtitle = t7;
  let t8;
  if ($[11] !== count || $[12] !== subtitle || $[13] !== t || $[14] !== title) {
    t8 = {
      t,
      count,
      title,
      subtitle
    };
    $[11] = count;
    $[12] = subtitle;
    $[13] = t;
    $[14] = title;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};